export default __webpack_public_path__ + "static/media/home_air_purifiers.4dd82ece.png";